/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Button } from '@mui/material';
import {
  GET_STRIPE_OAUTH_URL,
  UPDATE_GATEWAY_SETTING_API_URL,
} from 'api/apiConstants';
import { GatewayInfoType } from 'containers/manage/gateways/GatewaysListingType';
import { useSnackbar } from 'notistack';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import axiosInstance from 'utils/axios';
import { setSession } from 'utils/jwt';

type Props = {
  gatewayDetails: GatewayInfoType;
};

const StripeOnboarding: FunctionComponent<Props> = ({ gatewayDetails }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const gatewayId = gatewayDetails._id;
  const portalId = window.sessionStorage.getItem('portal_id');
  setSession(window.sessionStorage.getItem('user_token'));
  const updateGatewaySettings = async () => {
    enqueueSnackbar('Connecting to your stripe account...', {
      variant: 'info',
    });
    try {
      const result = await axiosInstance.post(
        `${UPDATE_GATEWAY_SETTING_API_URL}/${gatewayId}`,
        {
          payment_currency: 'usd',
          theme: 'stripe',
        }
      );
      if (result.data.success) {
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };

  const connectToStripe = async () => {
    try {
      const result = await axiosInstance.get(
        `${GET_STRIPE_OAUTH_URL}?portal_id=${portalId}&onboarding=true&custom_url=${window.location.protocol}//${window.location.host}`
      );
      if (result.data.success === true) {
        window.location.href = `${result.data.authUrl}`;
      }
    } catch (err) {
      enqueueSnackbar(err, { variant: 'error' });
    }
    updateGatewaySettings();
  };

  return (
    <>
      <Button
        variant='outlined'
        fullWidth
        onClick={connectToStripe}
        className='mt-5 normal-case'
      >
        {t('connect_your_stripe_acc')}
      </Button>
    </>
  );
};

export default StripeOnboarding;
